export const playlist = {
  'Public playlist': 'Liste de lecture publique',
  songs: 'chansons',
  Name: 'Nom',
  Skills: 'Compétences',
  Filter: 'Filtrer',
};
